import { post, get } from "@/api/http";
import profile from "@/api/profile";
import main from "@/api/main";

const _api2 = profile.apiUrl[main.getServerLocation()];

export default {
    // 創建遊戲活動
    createGameActivity: function (data) {
        return post("/gameactivity/create-gameactivity", data);
    },

    // 獲取我的遊戲活動列表（支援搜尋與分頁）
    getMyGameActivities: function (data) {
        return post("/gameactivity/get-my-gameactivities", data);
    },

    // 更新遊戲活動
    updateGameActivity: function (data) {
        return post("/gameactivity/update-gameactivity", data);
    },

    // 獲取單一遊戲活動（公開）
    getGameActivity: function (data) {
        return post("/gameactivity/get-gameactivity", data);
    },

    // 刪除遊戲活動
    deleteGameActivity: function (data) {
        return post("/gameactivity/delete-gameactivity", data);
    },

    // 提交遊戲成績（不需登入）
    submitScore: function (data) {
        return post("/gameactivity/submit-score", data);
    },

    // 查詢活動成績列表（需登入）
    getActivityScores: function (data) {
        return post("/gameactivity/get-activity-scores", data);
    },

    // 檢查活動數量限制（需登入）
    checkActivityLimit: function (data) {
        return post("/gameactivity/check-activity-limit", data);
    },

    // 取得縮圖上傳 SAS Token（需登入）
    getThumbnailSasToken: function () {
        return post("/gameactivity/thumbnail-sas", {});
    },

    // 首次發布自製遊戲到公開 Gallery（需登入）
    publishCustomGame: function (data) {
        return post("/gameactivity/publish-custom-game", data);
    },

    // 覆蓋更新已發布的公開版本（需登入）
    updatePublicCustomGame: function (data) {
        return post("/gameactivity/update-public-custom-game", data);
    },

    // 刪除公開版本（需登入）
    deletePublicCustomGame: function (data) {
        return post("/gameactivity/delete-public-custom-game", data);
    },

    // 查詢個人已公開列表（需登入）
    getMyPublicCustomGames: function (data) {
        return post("/gameactivity/get-my-public-custom-games", data);
    },

    // 取得單一公開遊戲（不需登入）
    getPublicGame: function (publicId) {
        return get(`/gameactivity/get-public-game`, { publicId });
    },

    // 取得所有公開自製遊戲（不需登入）
    getPublicCustomGames: function (data) {
        return post("/gameactivity/get-public-custom-games", data);
    },

    // 複製公開遊戲到個人活動（需登入）
    copyPublicGame: function (data) {
        return post("/gameactivity/copy-public-game", data);
    },

    // 產生短碼（呼叫 TeamModel ClipCode 服務）
    createClipCode: function (origData, lang, note) {
        return post(_api2 + "/Service/CreateClipCodes", {
            origDataList: [{ origData }],
            type: "url",
            useShortDigits: false,
            isPermanent: false,
            lang: (lang || "zh-tw").toLowerCase(),
            note: note || ""
        });
    }
}
